import React from 'react';
import './style.css';

const Layout = ({ children }) => {
  return (
    <>
      { children }
    </>
  );
};


export default Layout;